<template>
    <div class="row justify-content-center g-4">
        <div v-for="(item, index) in newestProviders" :key="index" class="col-xl-4 col-lg-4 col-md-6 col-sm-12">
            <GridLayout2 :item="item" :border="border"/>
        </div>
    </div>
</template>

<script setup>
    import {defineProps,ref,onMounted,watch} from 'vue'
    import axios from "axios";
    import GridLayout2 from './grid-layout2.vue';
    import { useI18n } from "vue-i18n";
    const { locale } = useI18n();
    defineProps({
        border:Boolean
    })
    const providers = ref([])
    const newestProviders = ref([])
    const fetchLatestProviders = async () => {
    try {
        const res = await axios.get("/users/list-service-provider?sortBy=new", {
            headers: {
                'locale': locale.value
            }
        });
        providers.value = res.data.service_providers
        newestProviders.value = res.data.service_providers
        .slice(0, 6)
    
    } catch (error) {
        console.error('Error fetching providers:', error)
    }
    }
    onMounted(() => {
    fetchLatestProviders();
    });
    watch(locale, () => {
        fetchLatestProviders();
    });
</script>
